export const MAGIC_SEARCH_BOOKING_STATUS_ACTIVE = 'active';
export const MAGIC_SEARCH_BOOKING_STATUS_CANCELLED = 'cancelled';

export type MagicSearchBookingStatus =
  | typeof MAGIC_SEARCH_BOOKING_STATUS_ACTIVE
  | typeof MAGIC_SEARCH_BOOKING_STATUS_CANCELLED;

export interface MagicSearchClub {
  id: string;
  legacyId: number;
  /** Null for a venue without a slug: PRO has no URL for it, so its results come back not navigable. */
  slug: string | null;
  name: string;
}

export interface MagicSearchCompany {
  id: string;
  legacyId: number;
  name: string;
}

export interface MagicSearchEvent {
  id: string;
  legacyId: number;
  name: string | null;
  startingTime: number | null;
  endingTime: number | null;
  timezone: string | null;
  isPublished: boolean;
  isArchived: boolean;
  coverUrl: string | null;
  club: MagicSearchClub | null;
  company: MagicSearchCompany | null;
  isNavigable: boolean;
}

export interface MagicSearchVenueCompany extends MagicSearchCompany {
  isOwner: boolean;
}

export interface MagicSearchVenue {
  id: string;
  legacyId: number;
  name: string;
  slug: string;
  cityName: string | null;
  /** Owner first, then by name, every one of them. Never empty: PRO cannot open a venue no company runs. */
  companies: MagicSearchVenueCompany[];
}

export interface MagicSearchBookingEvent {
  id: string;
  legacyId: number;
  name: string | null;
  startingTime: number | null;
  timezone: string | null;
}

export interface MagicSearchBooking {
  id: string;
  legacyId: number;
  fullName: string | null;
  email: string | null;
  tickets: number;
  total: number;
  currency: string | null;
  status: MagicSearchBookingStatus;
  createdAt: number | null;
  event: MagicSearchBookingEvent;
  club: MagicSearchClub | null;
  company: MagicSearchCompany | null;
  isNavigable: boolean;
}

/** `GET /v1/admin/search` (monolith), XCEED admins only. Every section is always present. */
export interface MagicSearchResults {
  events: MagicSearchEvent[];
  venues: MagicSearchVenue[];
  bookings: MagicSearchBooking[];
}
